






































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, ref } from "@vue/composition-api";
import { UseFormInput } from "@/common/composition/use-form-input";
export default Vue.extend({
  components: {
    Modal,
  },
  props: ["modalData"],
  setup(_, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      height: "auto",
      withTopRightCloseBtn: true,
    };

    const [connection_name, is_connection_name_valid] = UseFormInput<string>(
      "",
      [(s) => s.length > 0]
    );

    const show_password = ref(false);

    const get_inputs = (): HTMLInputElement[] =>
      Array.from(document.querySelectorAll(".kv-field")) as HTMLInputElement[];

    const are_connection_fields_valid = ref(false);
    const is_all_input_valid = computed(
      () => are_connection_fields_valid.value && is_connection_name_valid.value
    );
    const on_key_press = () => {
      are_connection_fields_valid.value = get_inputs().every(
        (d) => d.value.trim().length > 0
      );
    };

    const submit_fields = () => {
      const key_vals = get_inputs().map((d) => [d.name, d.value]);
      const fields = key_vals.reduce((acc, [k, v]) => {
        acc[k] = v;
        return acc;
      }, {} as Record<string, string>);
      emit("submit", { connection_name: connection_name.value, fields });
    };

    return {
      config,
      is_all_input_valid,
      are_connection_fields_valid,
      is_connection_name_valid,
      on_key_press,
      submit_fields,
      connection_name,
      show_password,
    };
  },
});
